import { Divider, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import Intent from './intent';
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import { useIntentStore } from '../../../store/intentStore';

const IntentGlobal = () => {

    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const setFlagCreateIntentPopup = useIntentStore((state) => state.setFlagCreateIntentPopup);

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={"Intent"}
                                    flagMainTextOnly 
                                    actionBlock={
                                        !smallScreen && 
                                        <GlobalButton
                                            buttonText="New Intent"
                                            className='primaryButtonStyle'
                                            startIcon={<AddIcon />}
                                            sx={{ width: "140px" }}
                                            onClick={() => setFlagCreateIntentPopup(true)}
                                        />
                                    }
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle}`} sx={{ paddingTop: "15px !important" }} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{ padding: "25px 25px 0 27px" }}>
                        <Intent />
                    </Grid>
                    

                </Grid>
            </Grid>
        </>
    )
}

export default IntentGlobal
